import { render } from "./AlternativeMobileApp.vue?vue&type=template&id=f03e9a3c&scoped=true"
import script from "./AlternativeMobileApp.vue?vue&type=script&lang=js"
export * from "./AlternativeMobileApp.vue?vue&type=script&lang=js"

import "./AlternativeMobileApp.vue?vue&type=style&index=0&id=f03e9a3c&scoped=true&lang=css"

import exportComponent from "/home/armin/w/euro-petrol-website/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f03e9a3c"]])

export default __exports__